export default __webpack_public_path__ + "static/media/404.c0bc7d0b.png";